import { REQUEST } from 'utils/actionGenerator';
import { takeLatest } from 'redux-saga/effects';
import * as api from './api';
import { fetchEntitySpawn } from 'store/saga';
import * as placesActions from './actions';

export function* getSearchResults(action) {
  const { query, addressTypes, setSourceAsGoogle } = action.params;
  const request = api.getSearchResultsRequest(query, addressTypes, setSourceAsGoogle);
  yield fetchEntitySpawn(request, placesActions.getSearchResults);
}

export function* selectPlace(action) {
  const { payload } = action.payload;
  const request = api.selectPlaceRequest(payload);
  yield fetchEntitySpawn(request, placesActions.selectPlace);
}

function* mySaga() {
  yield takeLatest(placesActions.GET_SEARCH_RESULTS[REQUEST], getSearchResults);
  yield takeLatest(placesActions.SELECT_PLACE[REQUEST], selectPlace);
}

export default mySaga;
